import React, { forwardRef, useEffect, useState } from 'react'
import { useAuthenticated } from 'react-admin';

const Private = ({ children }) => {
    useAuthenticated(); // redirects to login if not authenticated

    return children
  }

  export default Private